import { FunctionComponent } from "react";

import { MicroFrontends } from "./MicroFrontends";
import { PageNotFoundListener } from "./PageNotFoundListener";

export const Main: FunctionComponent = () => {
  return (
    <div>
      <main id="main-content">
        <MicroFrontends />
        <PageNotFoundListener />
      </main>
    </div>
  );
};
